import { isServer } from './server';
import { PlcNextPageContext } from 'features/business/app.types';

export function handleScrollTop() {
  if (isServer()) {
    return;
  }
  window.scrollTo({ behavior: 'auto', top: 0 });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getHost(req?: any) {
  // Force https
  const protocol = 'https';
  let plcHostname = 'www.pleinchamp.com';
  if (typeof window !== 'undefined') {
    const {
      location: { hostname },
    } = window;
    plcHostname = hostname;
  } else if (req && req.get) {
    plcHostname = req.get('host');
  }

  return `${protocol}://${plcHostname}`;
}

export function isMobileDevice(ctx: PlcNextPageContext) {
  const userAgent = ctx.req ? ctx.req.headers['user-agent'] : navigator.userAgent;
  return userAgent ? /(iPad|iPhone|Android|Mobile)/i.test(userAgent) : false;
}
